export default "__VITE_ASSET__BJ6LHa8q__"